export default __webpack_public_path__ + "53a1bce47f52e29efc5062b773ee9593.png";